import RestService from './RestService';

export async function getBrand(domain, slug) {
	const res = await RestService.performRestOpNext(`brand/get-raw`, {
		domain, slug
	});
	return res;
}


export async function createBrand(brand) {
	const res = await RestService.performRestOpNext(`brand/create`, brand);
	return { domain: brand.domain, slug: brand.slug };
}

export async function updateBrand(brand) {
	const res = await RestService.performRestOpNext(`brand/update`, brand);
	return res;
}